export const UNKNOWN = 'UNKNOWN';
export const BANK_STATEMENT = 'BANK_STATEMENT';
export const PAYSLIP = 'PAYSLIP';
export const TAX_FORM = 'TAX_FORM';
export const INVOICE = 'INVOICE';
export const UTILITY_BILL = 'UTILITY_BILL';
export const CHECK = 'CHECK';
export const DRIVING_LICENSE = 'DRIVING_LICENSE';
export const SOCIAL_SECURITY_CARD = 'SOCIAL_SECURITY_CARD';
export const BUSINESS_FILING = 'BUSINESS_FILING';
export const FINANCIAL_STATEMENT = 'FINANCIAL_STATEMENT';
export const BENEFITS_STATEMENT = 'BENEFITS_STATEMENT';
export const INSURANCE_STATEMENT = 'INSURANCE_STATEMENT';
export const LEASE = 'LEASE';
export const INVESTMENT_STATEMENT = 'INVESTMENT_STATEMENT';
export const CREDIT_CARD_STATEMENT = 'CREDIT_CARD_STATEMENT';
